import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ColumnHeader from 'components/NewHome/Table/ColumnHeader';
import Button from 'components/DesignSystem/Button';
import useFluxStatus from 'hooks/NewHome/Table/FluxStatus/useFluxStatus';
import { fromUnixTime } from 'date-fns';

export default function Status() {
  const {
    scenarios,
    acomphDates,
    forecastDates,
    setScenarios,
    setAcomphDates,
    setForecastDates,
    clearFilters,
    scenarioOptions,
    acomphDateOptions,
    forecastDateOptions,
    filteredItems,
  } = useFluxStatus();

  return (
    <div>
      <Row className="d-flex justify-content-end">
        <Col md="2" className="d-flex justify-content-end me-3">
          <Button
            type="tertiary"
            icon="no_filter"
            onClick={clearFilters}
          >
            Limpar Filtros
          </Button>
        </Col>
      </Row>
      <div className="ms-2 me-2">
        <Row className="mb-1 mt-2 ht-row">
          <ColumnHeader md={6} title="Cenário" value={scenarios} setValue={setScenarios} className="mr-3">
            {scenarioOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={2} title="Data Acomph" value={acomphDates} setValue={setAcomphDates}>
            {acomphDateOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={2} title="Data Previsão" value={forecastDates} setValue={setForecastDates}>
            {forecastDateOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={2} title="Última Atualização" filterless />
        </Row>
        <div className="ht-row-container">
          {filteredItems.map((item) => (
            <Row key={`flux-status-${item.id}`} className="pt-3 pb-3 ht-row ht-entry-row">
              <Col md={6} className="home-table-entry-name">{item.cenario}</Col>
              <Col md={2} className="home-table-entry-attr">{item.data_acomph}</Col>
              <Col md={2} className="home-table-entry-attr">{item.data_previsao}</Col>
              <Col md={2} className="home-table-entry-attr">{fromUnixTime(item.last_update).toLocaleString()}</Col>
            </Row>
          ))}
        </div>
      </div>
    </div>
  );
}
